import CONFIG from "../config.json";
import axios from "axios";

let client_url = CONFIG.BASE_URL;
let base_url = CONFIG.API_BASE_URL;

export const sendRequest = (
  url,
  type = CONFIG.GET,
  params = null,
  isFileUpload = false
) => {
  if (type === CONFIG.GET) {
    return axios.get(base_url + url, {
      headers: {
        Accept: "application/xml",
      },
    });
  } else {
    if (isFileUpload) {
      let formData = new FormData();
      for (let key in params) {
        formData.append(key, params[key]);
      }
      return axios.post(base_url + url, formData, {
        headers: {
          Accept: "application/xml",
        },
      });
    } else {
      if (!params["Captcha"]) {
        return axios.post(base_url + url, params, {
          headers: {
            Accept: "application/xml",
          },
        });
      } else {
        let captchaEncode = window.btoa(
          params["Captcha"] +
            "" +
            (params["Captcha"] + "").split("").reverse().join("") +
            (13 + Math.floor(new Date().getTime() / 1000))
        );
        return axios.post(base_url + url, params, {
          headers: {
            Accept: "application/xml",
            "captcha-response": captchaEncode,
          },
        });
      }
    }
  }
};

export const IMAGE_BASE_URL = CONFIG.IMAGE_BASE_URL;
